import Layout from "../../components/layout/Layout";
import RequestForm from "../../components/requests/RequestForm";
import { useParams } from "react-router-dom";
import styles from '../../components/requests/RequestForm/RequestForm.module.css';
const RequestFormPage = () => {
    const { idPedido } = useParams();
    const isEditMode = !!idPedido;

    return (
        <Layout>
            <div className={styles.page}>
                <RequestForm idPedido={idPedido} isEditMode={isEditMode} />
            </div>
        </Layout>
    );
}
export default RequestFormPage;